module.exports = __webpack_public_path__ + "static/img/nvzhujue.29ebb24.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/nvzhujue.png
// module id = Nb0N
// module chunks = 1